import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import { ipcApi, isMobile } from "utils"
import { Select } from "components"
import classes from "./PrinterBluetoothInterface.module.scss"

const PrinterBluetoothInterface = props => {
  const { form, setForm, formErrors } = props

  const [t] = useTranslation()

  const [options, setOptions] = useState([])

  const handleSelect = (select) => {
    setForm(prev => ({
      ...prev,
      deviceName: select.label,
      macAddress: select.value
    }))
  }

  const handleFocus = async () => {
    if (!isMobile()) return

    try {
      const devices =
        await ipcApi({
          type: "getBluetoothDevices"
        })

      const options =
        devices.map(device => ({
          label: device.name,
          value: device.address
        }))

      setOptions(options)
    } catch (err) {
      console.log(err)
    }
  }

  const getUsbDevicesList = async () => {
    if (!isMobile()) return

    const devices =
      await ipcApi({
        type: "getBluetoothDevices"
      })

    const options =
      devices.map(device => ({
        label: device.name,
        value: device.address
      }))

    setOptions(options)
  }

  useEffect(() => {
    getUsbDevicesList()
  }, [])

  const value =
    options.find(o => o.value === form.macAddress)
    ||
    (
      !!form.macAddress
        ?
        {
          label: form.deviceName,
          value: form.macAddress
        }
        :
        null
    )

  return (
    <Select
      isSearchable={false}
      value={value}
      options={options}
      onMenuOpen={handleFocus}
      onChange={handleSelect}
      noOptionsMessage={() => t("هیچ_پرینتری_یافت_نشد")}
      label={t("انتخاب_پرینتر")}
      placeholder={t("انتخاب_پرینتر")}
      className={classes["select"]}
      error={formErrors.deviceName}
    />
  )
}

export default PrinterBluetoothInterface